/* The default server version set before
 * any API call has been made to get the
 * database deployment options. Used as a
 * fallback.
 * */
export const DEFAULT_SERVER_VERSION = '7.1';

export const AVAILABILITY_ZONE = {
  single: 'Single',
  multi: 'Multiple',
} as const;
export type AvailabilityZones = keyof typeof AVAILABILITY_ZONE;

export const DEFAULT_TIME_ZONE = 'PT';

export const LIMITED_DISK_MODIFICATION_WARNING = `We noticed that there was a storage modification done in the last 6-hour period for one of your service groups. AWS allows
            storage modification only once in a 6-hour period. Changing the storage size will instead happen through node replacement and
            rebalancing of the data.`;

export const AZURE_AUTO_SCALE_WARNING = `Auto-expansion automatically expands storage for your cluster if your used disk capacity reaches 75%. This requires replacing and rebalancing nodes and might impact performance until the process completes. The service group storage size doubles, which can result in additional costs.`;

export const AUTO_SCALE_WARNING = `Capella automatically expands storage for your cluster if your used disk capacity reaches 75%. This can result in additional costs.`;
